import { makeVar } from '@apollo/client';

export const isGridEditableVar = makeVar(null);

export const isAssetLevelResidualValuesVar = makeVar(null);

export const highlightedItemIdVar = makeVar(null);

export const addItemsModalOpenVar = makeVar(false);

export const detailsLoadedItemIdsVar = makeVar([]);
